import { render, staticRenderFns } from "./AddressResponsibleEmployees.vue?vue&type=template&id=22db4f2c&scoped=true&lang=pug&"
import script from "./AddressResponsibleEmployees.vue?vue&type=script&lang=ts&"
export * from "./AddressResponsibleEmployees.vue?vue&type=script&lang=ts&"
import style0 from "./AddressResponsibleEmployees.vue?vue&type=style&index=0&id=22db4f2c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22db4f2c",
  null
  
)

export default component.exports